import { useTranslation } from 'react-i18next'
import { Breadcrumbs, Crumb } from '@carsys/ui'
import { AxaptaReturnPath, BasePath, CreateInvoicePathPath, DetailsPath, NewPath, RegisterPath } from 'app/rma/paths'
import { UUIDPathRegex } from '@cbgms/base/utils/uuid'

export const StockBreadCrumbs: React.FC<React.ComponentProps<typeof Breadcrumbs>> = ({ ...props }) => {
  const { t } = useTranslation()

  return (
    <Breadcrumbs {...props}>
      <Crumb
        data-testid='crumb-order-suggestion'
        key='crumb-order-suggestion'
        path='/stock/order-suggestion'
        text={t('OrderSuggestions.Warehouses')}
      />
      <Crumb
        data-testid='crumb-order-suggestion-view'
        key='crumb-order-suggestion-view'
        path={`/stock/order-suggestion/:uuid(${UUIDPathRegex})`}
        text={t('OrderSuggestions.Title')}
      />
      <Crumb data-testid='crumb-stock-part' key='crumb-stock-part' path='/stock/parts' text={t('warehouse_part.title')} />
      <Crumb
        data-testid='crumb-stock-part-uuid'
        key='crumb-stock-part-uuid'
        path='/stock/parts/:partUUID'
        text={params => (params.partUUID === 'new' ? t('warehouse_part.add_stock_part') : t('warehouse_part.edit_stock_part'))}
      />
      <Crumb data-testid='crumb-returns' key='crumb-returns' path={BasePath} text={t('rma.title')} />
      <Crumb
        data-testid='crumb-returns-new'
        key='crumb-returns-new'
        path={AxaptaReturnPath}
        text={t('rma.axapta-erp-return.axapta_erp_return')}
      />
      <Crumb data-testid='crumb-returns-new' key='crumb-returns-new' path={NewPath} text={t('rma.register-new')} />
      <Crumb data-testid='crumb-returns-edit' key='crumb-returns-edit' path={DetailsPath} text={t('rma.edit')} />
      <Crumb
        data-testid='crumb-returns-article'
        key='crumb-returns-article'
        path={RegisterPath}
        text={t('rma.return-article.return_article')}
      />
      <Crumb
        data-testid='crumb-returns-create-invoice'
        key='crumb-returns-create-invoice'
        path={CreateInvoicePathPath}
        text={t('externalinvoice.create_invoice')}
      />
      <Crumb data-testid='crumb-tyre-stock' key='crumb-tyre-stock' path='/stock/tyres' text={t('TyreStock.PageTitle')} />
      <Crumb
        data-testid='crumb-tyre-stock-uuid'
        key='crumb-tyre-stock-uuid'
        path='/stock/tyres/:tyreStorageUUID'
        text={params => (params.tyreStorageUUID === 'new' ? t('global.new') : t('global.edit'))}
      />
    </Breadcrumbs>
  )
}

export default StockBreadCrumbs
